<!-- <ng-container *ngIf="!!loading;then loadingtemp;else datatemp"></ng-container>
<ng-template #datatemp> -->
  <div class="d-flex" [ngClass]="theme ? 'bg-light-white': 'dark' ">
    <div class="container-fluid vh-100 overflow-auto" [ngClass]="theme ? '': 'banner' ">
      <div class="row m-0 p-3">
        <div class="card col-12 mb-5 create-content-dark-card">
  
          <!-- Heading -->
          <div class="border-bottom">
            <h1 class="fw-bold text-dark mb-1 light-txt fs-32">Audit</h1>
            <p class="fw-bold Neutral dark-content fs-16">Optimize your existing page with Top 20 Competitors data</p>
          </div>
          <div class="mt-pt-2">
            <form action="" [formGroup]="auditForm">
              <div class="position-relative">
                <i class="bi bi-search prefix text-primary"></i>
                <input type="text" class="form-control input ps-56" placeholder="Enter your Keyword ..."
                  formControlName="keyWord">
              </div>
              <div class="position-relative mt-4">
                <i class="bi bi-link-45deg prefix text-primary fs-20"></i>
                <input type="text" class="form-control input ps-56" placeholder="Enter your page URL ..."
                  formControlName="url">
              </div>
            </form>
            <div class="row my-4">
              <div class="col-4">
                <label class="fw-600 Neutral fs-14 mb-1">Country</label>
                <mat-form-field appearance="outline" class="w-100 country-input flag-input"
                  [ngClass]="theme ? '': 'dark-input' ">
                  <img [src]="selectedFlag !=='' ? selectedFlag : defaultFlag" alt="" width="34" height="24"
                    class="selected-flag">
                  <mat-select [(ngModel)]="selected" (keyup.enter)="checkEnter($event,'country')" [disableOptionCentering]="true" panelClass="{{selectMenu}}">
                    <div class="p-2">
                      <input type="text" class="form-control input" placeholder="Search ..."
                        (keyup)="searchDropDownData($event,'country')">
                    </div>
                    <mat-option *ngFor="let data of dropDownCountry" style="margin: 0 10px;"
                      (click)="getSelectedFlag(data.code.split(':')[1],data?.country,'')" [value]="data?.country">
                      <img loading="lazy" src="https://flagpedia.net/data/flags/normal/{{data.code.split(':')[1]}}.png" alt="" width="34"
                        height="24" class="selected-flag">
                      <span class="fs-16 ms-4 ps-1">{{data?.country}}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <label class="fw-600 fs-14 Neutral mb-1">Language</label>
                <mat-form-field appearance="outline" class="w-100 country-input" [ngClass]="theme ? '': 'dark-input' ">
                  <mat-select [(ngModel)]="languageType" panelClass="{{selectMenu}}" [disableOptionCentering]="true">
                    <div class="p-2">
                      <input type="text" class="form-control input" placeholder="Search ..."
                        (keyup)="searchDropDownData($event,'language')">
                    </div>
                    <mat-option *ngFor="let data of languageDropdown" (click)="languageType===data.code"
                      [value]="data.code">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <label class="fw-600 fs-14 Neutral mb-1">Crawler type</label>
                <mat-form-field appearance="outline" class="w-100 country-input" [ngClass]="theme ? '': 'dark-input' ">
                  <mat-select [(ngModel)]="crawlType" panelClass="{{selectMenu}}" [disableOptionCentering]="true">
                    <mat-option value="Mobile">Mobile</mat-option>
                    <mat-option value="Desktop">Desktop</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="" >
              <button class="btn btn-primary me-2" [disabled]="auditForm.invalid || unCompletedCount.length != 0 || count > 0 || (totalCredits - remainingCredits ==0)"
                (click)="openCreateContentModal(CreateContent);submitAudit()">Create Audit</button>
                <button class="btn btn-primary me-2" [disabled]="unCompletedCount.length != 0 || (totalCredits - remainingCredits ==0)" (click)="bulkContent()">Bulk mode</button>
            </div>
              <div class="d-flex align-items-center">
              <button style="float:right" class="btn btn-primary me-2" (click)="globalSetting()" ngbPopover="Set up the default preferences, including country, language" popoverClass="{{popover}}" container="body" triggers="mouseenter:mouseleave"><i class="me-1 bi bi-gear"></i>Default Setting</button>
              <label class="fs-16 Neutral">NLP always on</label>
              <div class="form-switch ms-3">
                <input class="form-check-input no-click" [checked]="nlp" type="checkbox" role="switch" id="checkBox">
              </div>
            </div>
          </div>
        </div>
  
        <nav class="nav border-bottom mb-4" [ngClass]="theme ? 'light-nav-link': 'dark-nav-link' ">
          <a class="nav-link dark-link fw-bold fs-20 text-decoration-none" [ngClass]="{'active': activateLink == 'Audit report list'}"
            role="button" (click)="activeLink('Audit report list')">Audit report list</a>
<!--           <a class="nav-link dark-link fw-bold fs-20 text-decoration-none" role="button" [ngClass]="{'active': activateLink == 'Shared with me'}"
            (click)="activeLink('Shared with me')">Shared with me</a> -->
        </nav>

        <ng-template #globalSettings let-modal>
          <div class="p-4">
              <div class="position-relative heading-border pb-3">
                  <h1 class="fw-bold m-0 heading">Set Default Setting</h1>
                  <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">
                      <i class="bi bi-x-lg fw-bold text-white" *ngIf="!theme"></i>
                  </button>
              </div>
              <div class="overflow-content">
                  <div class="mt-1">
                      <div class="country-box">
                          <div class="col-10 mb-3">
                              <label class="fw-600 fs-14 text-gray">Country</label><br>
                              <mat-form-field appearance="outline" class="w-100 country-input flag-input"
                                  [ngClass]="theme ? '': 'dark-input' ">
                                  <img [src]="selectedglobalSettingsFlag !=='' ? selectedglobalSettingsFlag : defaultGlobalSettingsFlag"
                                      alt="" width="34" height="24" class="selected-flag">
                                  <mat-select [(ngModel)]="globalSettingsSelectedCountry" (keyup.enter)="checkEnter($event,'global')"
                                      [disableOptionCentering]="true" panelClass="{{selectMenu}}">
                                      <div class="p-2">
                                          <input type="text" class="form-control input"
                                              placeholder="Search ..."
                                              (keyup)="searchDropDownDataGlobal($event,'country')">
                                      </div>
                                      <mat-option *ngFor="let data of dropDownCountryGlobal"
                                          (click)="getSelectedFlag(data.code.split(':')[1],data?.country,'globalSetting')"
                                          [value]="data?.country">
                                          <img loading="lazy" src="https://flagpedia.net/data/flags/normal/{{data.code.split(':')[1]}}.png"
                                              alt="" width="34" height="24">
                                          <span class="fs-16 ms-4 ps-1">{{data?.country}}</span>
                                      </mat-option>
                                  </mat-select>
                              </mat-form-field>
                          </div>
                          <div class="col-10 mb-3">
                              <label class="fw-600 fs-14 Neutral">Language</label>
                              <mat-form-field appearance="outline" class="w-100 country-input"
                                  [ngClass]="theme ? '': 'dark-input' ">
                                  <mat-select [(ngModel)]="globalSettingslanguageType"
                                      panelClass="{{selectMenu}}" [disableOptionCentering]="true">
                                      <div class="p-2">
                                          <input type="text" class="form-control input"
                                              placeholder="Search ..."
                                              (keyup)="searchDropDownDataGlobal($event,'language')">
                                      </div>
                                      <mat-option *ngFor="let data of languageDropdownGlobal"
                                          (click)="languageType===data.code"
                                          [value]="data.code">{{data.name}}</mat-option>
                                  </mat-select>
                              </mat-form-field>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="d-flex mt-4 justify-content-center">
                  <button class="btn btn-outline-primary me-1 px-5"
                      (click)="updateSettings()">Update</button>
              </div>
          </div>
      </ng-template>
  
        <div class="w-fill pr-2 border-right">
          <!-- Sort -->
          <div class="d-flex align-items-center justify-content-end mb-4" *ngIf="!loading">
            <label class="me-3 fs-16 fw-500 light-neutral">View by tag</label>
            <mat-form-field appearance="outline" class="me-4 w-200 fs-16" [ngClass]="theme ? '': 'dark-input' ">
              <mat-select value="Black huckleberry" (selectionChange)="getFilteredData('ViewByTag')"
                panelClass="{{selectMenu}}" [(ngModel)]="viewByTag">
                <mat-option value="All">All</mat-option>
                <mat-option [value]="i.tag" *ngFor="let i of tagArray">{{i.tag}}</mat-option>
              </mat-select>
            </mat-form-field>
            <label class=" me-3 fs-16 fw-500 light-neutral">Sort by</label>
            <mat-form-field appearance="outline" class="w-200 fs-16" [ngClass]="theme ? '': 'dark-input' ">
              <mat-select [value]="selectedValue" [(ngModel)]="selectedValue"
                (selectionChange)="getFilteredData('sortArg')" panelClass="{{selectMenu}}">
                <mat-option value="Mobile only">Mobile only</mat-option>
                <mat-option value="Desktop only">Desktop only</mat-option>
                <mat-option value="All">All</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <!-- Keywords Card -->
          <div class="row m-0 keyword-card-box border-0">
            <ng-container *ngIf="!!loading;then loadingg;else cards"></ng-container>
            <ng-template #loadingg>
              <div class="" style="width: 100%;height: 150px;display: flex;justify-content: center;align-items: center;">
                <div class="spinner-border text-primary" role="status" style="height: 40px;width: 40px;border-width: 5px;">
                </div>
                <span class="sr-only ms-2">Loading...</span>
              </div>
            </ng-template>
            
        
            <ng-template #cards>
            <!-- Keyword Details card -->
            <div class="w-33 w-half w-full p-12" *ngIf="isCreateContentMinimize && count<100">
              <div class="border-cyan position-relative rounded-4 h-100 p-4">
                <h2 class="m-0 border-bottom mb-3 fw-bold">{{dataObj1?.keyword}}</h2>
                <div class="d-flex align-items-center justify-content-between mb-3rem">
                  <div class="d-flex align-items-center">
                    <img src="../../../assets/icons/calender.svg" class="me-2" />
                    <!-- <i class="bi bi-calendar4 text-light-gray me-2"></i> -->
                    <span class="Neutral">{{date | date : 'd MMM,y'}} <i class="bi bi-dot text-light-gray"></i>
                      {{date | date : 'HH:mm'}}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img [src]="selectedFlag ? selectedFlag : defaultFlag" alt="" height="16" width="23" class=" me-2">
                    <span>{{countryValue}}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <!-- <i class="bi bi-phone text-light-gray fs-16 me-2" *ngIf="crawlType == 'Mobile'"></i>
                    <i class="bi bi-display text-light-gray fs-16 me-2" *ngIf="crawlType == 'Desktop'"></i> -->
                    <img src="../../../assets/icons/mobile.svg" class="me-2" *ngIf="crawlType == 'Mobile'" />
                    <img src="../../../assets/icons/desktop.svg" class="me-2" *ngIf="crawlType == 'Desktop'" />
                    <span class="Neutral">{{crawlType}}</span>
                  </div>
                </div>
                <div class="progress-box">
                  <label>Creating</label>
                  <div class="progress" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar progressbar-cyan" [ngStyle]="{ width: count + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-33 w-half w-full p-12" *ngFor="let data of auditData">
              <div class="p-4 py-2 keyword-border" [ngClass]="theme ? 'keyword-card' : 'dark-card'">
                <div class="row border-bottom mb-3">
                  <div class="col-md-10" style="height: 32px;">
                    <h2 class="m-0 fw-bold dark-black light-neutral ellipsis" > <span class="wrapped-text" matTooltip="{{data.keyword}}">{{data.keyword}}</span></h2>
                    <!-- <i class="bi bi-check-circle text-green ms-2 fs-5" *ngIf="activateLink !== 'Shared with me'"></i> -->
                  </div>
  
                  <div class="col-md-2 d-flex justify-content-end align-items-center"
                    *ngIf="data.status==='Loading' && data.is_bulk == false && startdate < createdDate(data.created)">
                    <div class="spinner-border text-primary pt-1" role="status"
                      style="width: 15px !important; height: 15px !important;"></div>
                  </div>
                  <div class="col-md-2 d-flex justify-content-end align-items-center" *ngIf="data.status==='Loading' && data.is_bulk == true && bStartdate < createdDate(data.created)">
                    <div class="spinner-border text-primary pt-1" role="status"
                      style="width: 15px !important; height: 15px !important;"></div>
                  </div>
                  <div class="col-md-2 d-flex justify-content-end align-items-center"
                    *ngIf="data.status==='Loading' && data.is_bulk == false && startdate > createdDate(data.created)">
                    <i class="bi bi-arrow-clockwise fs-24 text-primary me-2" matTooltip="Retry" role="button"
                      (click)="openCreateContentModal(CreateContent,data?.keyword);retryAudit(data)"></i>
                      <img src="../../../assets/icons/delete.svg" matTooltip="Delete Report" class="me-2" role="button"
                        (click)="deleteEditorReport(data.aid)" />
                  </div>
                  <div class="col-md-2 d-flex justify-content-end align-items-center" *ngIf="data.status==='Loading' && data.is_bulk == true && bStartdate > createdDate(data.created)">
                    <i class="bi bi-arrow-clockwise fs-24 text-primary me-2" matTooltip="Retry" role="button"
                      (click)="openCreateContentModal(CreateContent,data?.keyword);retryAudit(data)"></i>
                      <img src="../../../assets/icons/delete.svg" matTooltip="Delete Report" class="me-2" role="button"
                        (click)="deleteEditorReport(data.aid)" />
                  </div>
                  <div class="col-md-2 d-flex justify-content-end align-items-center" *ngIf="data.status==='Retry' && (startdate > createdDate(data.created) || startdate < createdDate(data.created))">
                    <i class="bi bi-arrow-clockwise fs-24 text-primary me-2" matTooltip="Retry" role="button"
                      (click)="openCreateContentModal(CreateContent,data?.keyword);retryAudit(data)"></i>
                      <div class="action-icon">
                        <img src="../../../assets/icons/delete.svg" matTooltip="Delete Report" class="me-2" role="button"
                          (click)="deleteEditorReport(data.aid)" />
                      </div>
                  </div>
                  <div class="col-md-2 d-flex justify-content-end align-items-center" *ngIf="data.status==='Completed' || data.status==='Refreshing'">
                    <div class="action-icon">
                      <!-- <img src="../../../assets/icons/eye-slash.svg" class="me-2" role="button"/> -->
                      <img src="../../../assets/icons/delete.svg" matTooltip="Delete Report" class="me-2" role="button"
                        (click)="deleteEditorReport(data.aid)" />
                    </div>
                    <i class="bi bi-arrow-right-short fs-24 text-primary" role="button" 
                     matTooltip="View Report"
                      (click)="navigateToAuditDetail(data.aid)"></i>
  
                  </div>
  
                </div>
                <div class="email-chip d-flex align-items-center p-1 mb-3" style="width: fit-content;"
                  *ngIf="activateLink == 'Shared with me'">
                  <img [src]="data.profileImage" class="rounded-circle" height="20" width="20" alt="">
                  <span class="text-gray m-0 mx-2">{{data.email}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div class="d-flex align-items-center">
                    <img src="../../../assets/icons/calender.svg" class="me-2" />
                    <!-- <i class="bi bi-calendar4 text-light-gray me-2"></i> -->
                    <span class="Neutral lh-10 fs-14 fw-500 light-neutral">{{data.created | date : 'd MMM,y'}} <i
                        class="bi bi-dot text-light-gray"></i> {{data.created | date
                      :
                      'HH:mm'}}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img src="https://flagpedia.net/data/flags/normal/{{data.flag}}.png" alt="" height="16" width="23"
                      class=" me-2">
                    <span class="dark-content">{{data.country}}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <!-- <i class="bi bi-phone text-light-gray fs-16 me-2" *ngIf="data.device == 'Mobile'"></i>
                    <i class="bi bi-display text-light-gray fs-16 me-2" *ngIf="data.device == 'Desktop'"></i> -->
                    <img src="../../../assets/icons/mobile.svg" class="me-2" *ngIf="data.device == 'Mobile'" />
                    <img src="../../../assets/icons/desktop.svg" class="me-2" *ngIf="data.device == 'Desktop'" />
                    <span class="Neutral dark-content">{{data.device}}</span>
                  </div>
                </div>
                <div class="mb-3 dark-content">
                  <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 fs-14 fw-500 Neutral dark-content">Content score</h3>
                    <h3 class="m-0 dark-content"
                      [ngClass]="{'text-red' : data?.progress <= 20 , 'text-yellow': data?.progress >= 20 && data?.progress <= 50, 'text-green': data?.progress >= 50}">
                      {{data?.score}}%</h3>
                  </div>
                  <mat-progress-bar mode="determinate" [value]="data?.score"
                    [ngClass]="{'progressbar-red' : data?.progress <= 20 , 'progressbar-yellow': data?.progress >= 20 && data?.progress <= 50, 'progressbar-green': data?.progress >= 50}">
                  </mat-progress-bar>
                </div>
                <div class="d-flex flex-wrap add-light-card g-75">
                  <div class="text-gray rounded-pill d-flex round-border bg-light-white bg-dark-neutral"
                    style="padding: 8px 12px;">
                    <div (click)="openAddTagModel(addNewTag,data.aid)" role="button"><i class="bi bi-plus-lg"></i></div>
                  </div>
                  <div *ngFor="let i of data.auditTag">
                    <div class="text-gray rounded-pill d-flex p-2 round-border bg-light-white bg-dark-neutral">
                      <span class="px-2 fw-600 border-right fs-12">{{ tagCounts[i.tag] }}</span>
                      <span class="fw-600 px-2 fs-12">{{i.tag}}</span>
                      <i class="bi bi-x-lg px-2 fs-12" style="cursor: pointer;"
                        (click)="removeTag(data.auditTag,i.tag,data.aid)"></i>
                    </div>
                  </div>
                  <!-- <div class="text-gray rounded-pill d-flex p-2 me-2 round-border">
                    <span class="px-2 fw-600">76</span>
                    <span class="fw-600">Quince</span>
                    <i class="bi bi-x-lg ps-3 pe-2"></i>
                  </div> -->
                </div>
              </div>
            </div>
          </ng-template>

            <div class="d-flex justify-content-center" [ngClass]="theme ? '': 'dark-load' ">
              <div class="border border-light border-2 rounded-4 fw-600 px-3 py-12 d-inline-block"
                *ngIf="!loading && backupAuditData.length > 20 && auditData.length < backupAuditData.length">
                <div class="spinner-border" role="status"></div>
                <span class="ms-2 dark-content">Load more</span>
              </div>
            </div>
          </div>
        </div>
        <div class="w-284 pl-2 pe-0">
  
          <!-- Credits -->
          <div class="text-center p-4" [ngClass]="theme ? 'credits-card': 'credits-dark-card' ">
            <h3 class="border-bottom pb-2 fw-bold fs-20 heading">Credits</h3>
  
            <!-- Progress Bar -->
            <circle-progress class="mb-3" [percent]="percent_remaining" [radius]="60" [space]="-8" [outerStrokeWidth]="8"
              [innerStrokeWidth]="8" [outerStrokeColor]="'#30B28C'" [innerStrokeColor]="'#7D7E8026'" [animation]="true"
              [subtitle]="'Remaining'" [subtitleFontSize]="'14'" [subtitleFontWeight]="'600'" [subtitleColor]="'#000'"
              [titleFontSize]="'24'" [unitsFontSize]="'24'" [titleFontWeight]="'700'"
              [unitsFontWeight]="'700'"></circle-progress>
  
            <div class="d-flex align-items-center justify-content-between mb-1">
              <div class="d-flex align-items-center">
                <i class="bi bi-dot fs-3 text-saffron"></i>
                <span class="Neutral dark-content">Remaining Credit</span>
              </div>
              <span class="list-data fw-500 fs-16 light-neutral">{{totalCredits == 'inf' ? 'inf' : totalCredits -
                remainingCredits}}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <i class="bi bi-dot fs-3 text-saffron"></i>
                <span class="Neutral dark-content">Total Credit</span>
              </div>
              <span class="list-data fw-500 fs-16 light-neutral">{{totalCredits}}</span>
            </div>
            <!-- <button class="btn btn-primary col-12 mt-3 mb-2"><i class="bi bi-gift me-2"></i>Earn credit</button> -->
            <!-- <div class="d-flex align-items-center justify-content-center">
              <a href="" class="text-decoration-none fw-500 me-1 fs-14">View all plans</a>
              <a href="" class="text-decoration-none"><i class="bi bi-arrow-right-short fs-4"></i></a>
            </div> -->
          </div>
  
          <!-- Tag -->
          <mat-accordion class="box-shadow-none ps-4">
            <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false"
              class="px-4 py-2 {{className}}">
              <mat-expansion-panel-header>
                <mat-panel-title class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <mat-icon *ngIf="!panelOpenState">keyboard_arrow_down</mat-icon>
                    <mat-icon *ngIf="panelOpenState">keyboard_arrow_up</mat-icon>
                    <h3 class="m-0 fw-bold ms-3">Tag</h3>
                  </div>
                  <mat-icon class="text-primary" role="button" (click)="openModal('AddTag','',0)">add</mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="px-1 py-2 d-flex align-items-center justify-content-between border-bottom tag-list"
                *ngFor="let tag of tagArray;let i=index">
                <h3 class="m-0 fs-14 dark-black light-neutral">{{tag?.tag}}</h3>
                <div class="d-flex align-items-center">
                  <i class="bi bi-three-dots-vertical me-2" role="button" [matMenuTriggerFor]="optionMenu"></i>
                  <h3 class="m-0 text-gray fs-14">{{tagCounts[tag?.tag] ? tagCounts[tag?.tag] : 0 }}</h3>
                </div>
                <mat-menu #optionMenu="matMenu" xPosition="before" class="{{menu}} audit-menu">
                  <button mat-menu-item class="w-100" (click)="openModal('RenameTag',tag.tag,i)"><i
                      class="bi bi-pencil me-2"></i> Rename</button>
                  <button mat-menu-item class="text-danger w-100" (click)="deleteTag(tag.tag)"><i
                      class="bi bi-trash3 me-2"></i>
                    Delete</button>
                </mat-menu>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
  
          <!-- Modal For Create Content editor -->
          <ng-template #CreateContent let-modal>
            <div class="p-4">
              <h1 class="fw-bold text-center pb-1">Create Audit</h1>
              <p class="m-0 text-center fs-16 pb-1">We are creating for keyword <span
                  class="text-primary">{{auditForm.controls['keyWord']?.value ? auditForm.controls['keyWord']?.value :
                  retryKeyword }}</span> </p>
              <p class="text-center fs-16 pb-1 mb-3">This may take few minutes!</p>
              <label>Creating...</label>
              <div class="progress" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                <div class="progress-bar progressbar-cyan" [ngStyle]="{width: count + '%'}"></div>
              </div>
              <div class="d-flex mt-4 justify-content-end pt-2">
                <button type="button" class="btn btn-outline-primary me-1 w-50"
                  (click)="minimizeCreateContentModal()">Minimize pop up</button>
              </div>
            </div>
          </ng-template>
  
          <ng-template #addNewTag let-modal>
            <div class="p-4">
              <div class="position-relative heading-border pb-3">
                <h1 class="fw-bold m-0 heading">Add New Tag</h1>
                <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
                  (click)="selectedTagAry = [];modal.dismiss('Cross click')">
                  <i class="bi bi-x-lg fw-bold text-white" *ngIf="!theme"></i>
                </button>
              </div>
              <div class="overflow-content">
                <div class="mt-3">
                  <!-- <label class="fw-600">Language</label> -->
                  <mat-form-field appearance="outline" class="w-100" [ngClass]="theme ? '': 'dark-input' ">
                    <mat-select placeholder="Select Tag to add" [(ngModel)]="selectedTagAry" panelClass="{{selectMenu}}"
                      multiple>
                      <!-- <div class="p-2">
                        <input type="text" class="form-control input"  (keyup)="searchDropDownData($event,'language')" placeholder="Search ...">
                      </div> -->
                      <mat-option *ngFor="let data of tagArray" [value]="data">{{data?.tag}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex mt-4 justify-content-end">
                <button type="button" class="btn btn-outline-primary me-1 px-5"
                  (click)="selectedTagAry = [];modal.close('Close click')">Cancel</button>
                <button type="button" class="btn btn-primary ms-1 px-5" [disabled]="selectedTagAry.length == 0"
                  (click)="addTagByAid()">Add</button>
              </div>
            </div>
          </ng-template>
  
        </div>
      </div>
    </div>
  </div>
<!-- </ng-template> -->

<!-- <ng-template #loadingtemp>
  <ng-template #customLoadingTemplate>
    <div class="custom-class">
    </div>
  </ng-template>
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"
    [template]="customLoadingTemplate"></ngx-loading>
</ng-template> -->
